import * as React from "react";
import { Fragment, useState } from "react";
import { Dialog, Disclosure, Popover, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  XMarkIcon,
  MinusCircleIcon,
} from "@heroicons/react/24/outline";
import { ChevronDownIcon, PlusCircleIcon } from "@heroicons/react/20/solid";
import CoffeeSVG from "../images/coffee.svg";
import axios from "axios";

function classNames(...classes: Array<string | boolean | undefined>) {
  return classes.filter(Boolean).join(" ");
}

type CategoryType = {
  _id: string;
  user: string;
  name: string;
  description: string;
  image: string;
  __v: number;
}[];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categories, setCategories] = React.useState<CategoryType>([]);
  const [userFName, setUserFName] = React.useState<string>("");

  const getStatus = () => {
    axios
      .get("https://odin-inventory.adaptable.app/api/status", {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        if (res.data) {
          setUserFName(res.data.user.firstName);
        }
      })
      .catch((err) => {
        window.location.href = "/signin";
      });
  };

  const getCategories = () => {
    axios
      .get("https://odin-inventory.adaptable.app/api/categories", {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        if (res.data) {
          console.log(res.data);
          setCategories(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  React.useEffect(() => {
    getCategories();
    getStatus();
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    window.location.reload();
  };

  return (
    <header className="bg-white">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <a href="/" className="-m-1.5 p-1.5" data-testid="logo-button">
            <span className="sr-only">Your Company</span>
            <img className="h-8 w-auto" src={CoffeeSVG} alt="" />
          </a>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <Popover.Group className="hidden lg:flex lg:gap-x-12">
          <Popover className="relative">
            <Popover.Button className="flex items-center gap-x-1 text-md font-semibold leading-6 text-gray-900">
              Categories
              <ChevronDownIcon
                className="h-5 w-5 flex-none text-gray-400"
                aria-hidden="true"
              />
            </Popover.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute -left-8 top-full z-30 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                <div className="p-4">
                  {categories.map((item) => (
                    <div
                      key={item._id}
                      className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-gray-50"
                    >
                      <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <img
                          className="h-8 w-auto"
                          alt="img"
                          src={item.image}
                        />
                      </div>
                      <div className="flex-auto">
                        <a
                          href={"/category/" + item._id}
                          className="block font-semibold text-gray-900"
                        >
                          {item.name}
                          <span className="absolute inset-0" />
                        </a>
                        <p className="mt-1 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                  <a
                    href="/category/form/add"
                    className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                  >
                    <PlusCircleIcon
                      className="h-5 w-5 flex-none text-gray-400"
                      aria-hidden="true"
                    />
                    Add Category
                  </a>
                  <a
                    href="/category/form/delete"
                    className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                  >
                    <MinusCircleIcon
                      className="h-5 w-5 flex-none text-gray-400"
                      aria-hidden="true"
                    />
                    Remove Category
                  </a>
                </div>
              </Popover.Panel>
            </Transition>
          </Popover>

          <a
            href="/inventory"
            className="text-md font-semibold leading-6 text-gray-900"
          >
            Inventory
          </a>
          <a href="/" className="text-md font-semibold leading-6 text-gray-900">
            Company
          </a>
        </Popover.Group>
        <div className="lg:flex lg:flex-1 lg:justify-end text-gray-900 text-md hidden items-center gap-3">
          <div>{userFName}</div>
          <img
            className="h-8 w-8 rounded-full"
            src="https://firebasestorage.googleapis.com/v0/b/odin-inventory-a3085.appspot.com/o/DefaultUser.png?alt=media&token=9d4ae83c-2194-489f-a821-c1c7197b46b2"
            alt=""
          />
          <Popover.Group className="hidden lg:flex lg:gap-x-12">
            <Popover className="relative">
              <Popover.Button className="flex items-center gap-x-1 text-md font-semibold leading-6 text-gray-900">
                <ChevronDownIcon
                  className="h-5 w-5 flex-none text-gray-400"
                  aria-hidden="true"
                />
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute -left-20 top-full z-30 mt-3 w-28 max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                  <button className="p-4 pl-6" onClick={logout}>
                    log out
                  </button>
                </Popover.Panel>
              </Transition>
            </Popover>
          </Popover.Group>
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img className="h-8 w-auto" src={CoffeeSVG} alt="" />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">
                        Categories
                        <ChevronDownIcon
                          className={classNames(
                            open ? "rotate-180" : "",
                            "h-5 w-5 flex-none"
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {[...categories].map((item) => (
                          <Disclosure.Button
                            key={item._id}
                            as="a"
                            href={"/category/" + item._id}
                            className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                          >
                            {item.name}
                          </Disclosure.Button>
                        ))}
                        <a
                          href="/category/form/add"
                          className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                        >
                          <PlusCircleIcon
                            className="h-5 w-5 flex-none text-gray-400"
                            aria-hidden="true"
                          />
                          Add Category
                        </a>
                        <a
                          href="/category/form/delete"
                          className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                        >
                          <MinusCircleIcon
                            className="h-5 w-5 flex-none text-gray-400"
                            aria-hidden="true"
                          />
                          Remove Category
                        </a>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <a
                  href="/inventory"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Inventory
                </a>
                <a
                  href="/"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Company
                </a>
              </div>
              <div className="flex flex-1 lg:justify-end text-gray-900 text-md lg:hidden items-center gap-3 py-6">
                <Popover.Group className="">
                  <Popover className="relative">
                    <Popover.Button className="flex items-center gap-x-1 text-md font-semibold leading-6 text-gray-900">
                      <ChevronDownIcon
                        className="h-5 w-5 flex-none text-gray-400"
                        aria-hidden="true"
                      />
                    </Popover.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute top-full z-30 mt-3 w-28 max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                        <button className="p-4 pl-6" onClick={logout}>
                          log out
                        </button>
                      </Popover.Panel>
                    </Transition>
                  </Popover>
                </Popover.Group>
                <div className="text-gray-900 text-md flex items-center gap-3">
                  <img
                    className="h-8 w-8 rounded-full"
                    src="https://firebasestorage.googleapis.com/v0/b/odin-inventory-a3085.appspot.com/o/DefaultUser.png?alt=media&token=9d4ae83c-2194-489f-a821-c1c7197b46b2"
                    alt=""
                  />
                  <div>{userFName}</div>
                </div>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};

export default Header;
